import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { ScrollService } from './scroll/scroll.service';

@Injectable({
  providedIn: 'root',
})
export class ActiveSectionService {
  private activeSectionSubject = new BehaviorSubject<string>('home');
  readonly activeSection$ = this.activeSectionSubject.asObservable();
  private stopObserver?: () => void;
  private hasSyncedInitial = false;

  constructor(
    private scrollService: ScrollService,
    private router: Router,
    private location: Location
  ) {}

  init(): void {
    if (this.stopObserver) return;

    this.stopObserver = this.scrollService.observeActiveSection((id) => {
      if (this.activeSectionSubject.value !== id) {
        this.activeSectionSubject.next(id);

        // Avoid overwriting the initial hash on reload before scroll settles.
        if (!this.hasSyncedInitial) {
          this.hasSyncedInitial = true;
          if (window.location.hash) {
            return;
          }
        }

        if (window.location.hash) {
          this.location.replaceState(`${this.router.url.split('#')[0]}#${id}`);
        }
      }
    });
  }

  destroy(): void {
    this.stopObserver?.();
    this.stopObserver = undefined;
    this.hasSyncedInitial = false;
  }
}
